import {Component, Vue} from 'vue-property-decorator';

interface Loader {
  [key: string]: boolean;
}

@Component
export default class LoadingMixin extends Vue {
  loader: Loader = {
    loading: false,
  };

  startLoading(name?: string) {
    this.$set(this.loader, name || 'loading', true);
  }

  finishLoading(name?: string) {
    this.$set(this.loader, name || 'loading', false);
  }
}
